module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DataTablePage', {
    attrs: {
      "mainColumn": "name",
      "longColumn": "type",
      "resource": "/dock/manufacturer",
      "title": "厂商管理",
      "label": "厂商管理",
      "labelName": "name",
      "toolbar": _vm.toolbar,
      "operation": _vm.operation,
      "operationWidth": 252,
      "tableFullList": _vm.tableFullList,
      "tableInitList": _vm.tableInitList,
      "filterFullList": _vm.filterFullList,
      "filterInitList": _vm.filterInitList,
      "createList": _vm.createList,
      "updateList": _vm.updateList,
      "columns": _vm.columns
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05093398","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/System/Manufacturer.vue
// module id = 1681
// module chunks = 1